import apiClient from 'api/base';
import { IUserGroup, IUserRole } from 'models/userGroup.model';

export const getUserGroups = async (): Promise<Array<IUserGroup>> => {
  const { data } = await apiClient.get('/user-groups');

  return data;
};

export const createUserGroup = async (name: string): Promise<IUserGroup> => {
  const { data } = await apiClient.post('/user-groups', { name });

  return data;
};

export const updateUserGroupName = async (
  userGroupId: string,
  newName: string,
): Promise<IUserGroup> => {
  const { data } = await apiClient.put(`/user-groups/${userGroupId}`, {
    name: newName,
  });

  return data;
};

export const deleteUserGroup = async (userGroupId: string): Promise<void> => {
  await apiClient.delete(`/user-groups/${userGroupId}`);
};

export const createUserRolesForAGroup = async (
  userGroupId: string,
  rolesList: Array<string>,
): Promise<Array<IUserRole>> => {
  const roles = rolesList.map((name) => name.trim()).filter(Boolean);

  if (!roles.length) return [];

  const { data } = await apiClient.post(
    '/user-roles/bulk',
    roles.map((name) => ({ name, groupId: userGroupId })),
  );

  return data;
};

export const updateRoleName = async (
  roleId: string,
  newName: string,
): Promise<IUserRole> => {
  const { data } = await apiClient.put(`/user-roles/${roleId}`, {
    name: newName,
  });

  return data;
};

export const deleteRoleName = async (roleId: string): Promise<IUserRole> => {
  const { data } = await apiClient.delete(`/user-roles/${roleId}`);

  return data;
};
